import { render, staticRenderFns } from "./Cotacoes.vue?vue&type=template&id=08f0434c&scoped=true&"
import script from "./Cotacoes.vue?vue&type=script&lang=js&"
export * from "./Cotacoes.vue?vue&type=script&lang=js&"
import style0 from "./Cotacoes.vue?vue&type=style&index=0&id=08f0434c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f0434c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08f0434c')) {
      api.createRecord('08f0434c', component.options)
    } else {
      api.reload('08f0434c', component.options)
    }
    module.hot.accept("./Cotacoes.vue?vue&type=template&id=08f0434c&scoped=true&", function () {
      api.rerender('08f0434c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Carteira/Cotacoes.vue"
export default component.exports